import { useState } from 'react';
import { Tabs, TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { PermissionEnum } from '../../../enums/PermissionEnum';
import { usePermissions } from '../../../hooks/usePermissions';
import UserRolesTable from '../components/UserRolesTable';
import UsersTable from '../components/UsersTable';
import classNames from 'classnames';

const UserManagementPage = () => {
  const { t } = useTranslation('userManagement');
  const { hasPermission } = usePermissions();
  const isAllowUserRoles = hasPermission([PermissionEnum.VIEW_USER_ROLE, PermissionEnum.USER_ROLE]);
  const isAllowUser = hasPermission([PermissionEnum.VIEW_USER, PermissionEnum.USER]);
  const [activeTab, setActiveTab] = useState('users');
  const [activeKey, setActiveKey] = useState(0);

  const items: TabsProps['items'] = [
    ...(isAllowUser
      ? [
          {
            key: 'users',
            label: t('users'),
            children: <UsersTable activeTab={activeTab}></UsersTable>,
          },
        ]
      : []),
    ...(isAllowUserRoles
      ? [
          {
            key: 'userRoles',
            label: t('userRoles'),
            children: <UserRolesTable></UserRolesTable>,
          },
        ]
      : []),
  ];

  return (
    <>
      <section className="mb-16 mt-12 w-full">
        <h5 className="text-[24px] text-headings-font-color sm:text-[36px]">
          {t('userManagement')}
        </h5>
      </section>

      <section className="mb-6 mt-16 grid w-fit grid-cols-2 rounded-lg bg-card-bg-color p-2">
        {items.map((item, index: number) => (
          <span
            key={index + item.key}
            className={classNames(
              'cursor-pointer px-3 py-2 text-center transition-colors duration-300 ease-in-out',
              { 'rounded-md bg-white text-primary': activeTab === item.key }
            )}
            onClick={() => {
              setActiveTab(item.key);
              setActiveKey(index);
            }}
          >
            {item.label}
          </span>
        ))}
      </section>

      {items[activeKey].children}
    </>
  );
};

export default UserManagementPage;
